export default "__VITE_ASSET__CICxziI9__"